import React, { useCallback } from 'react';

import { AiSuggestionsEntryPointValue } from '@atlaskit/editor-common/analytics/ai-suggestions-entry-points';
import { Inline } from '@atlaskit/primitives/compiled/inline';

import { useIsOffline } from '../useIsOffline.ts';
import { useSuggestionsSource } from '../useSuggestionsSource.ts';

import { SuggestionsFilterMenu } from './SuggestionsFilterMenu.tsx';
import { SuggestionsHeaderActions } from './SuggestionsHeader.tsx';

/**
 * The panel header renders its right-aligned element before the close button, so the filter menu
 * listed last here sits between the more menu and close. Suggestions are only acted on in the
 * editor, so view mode has no header actions.
 */
export const SuggestionsHeaderActionGroup = (): React.JSX.Element | null => {
	const source = useSuggestionsSource();
	const editorAPI = source.mode === 'editor' ? source.editorAPI : undefined;
	const isOffline = useIsOffline(editorAPI);
	const handleReview = useCallback(() => {
		editorAPI?.aiSuggestions?.actions.setThinkingState('thinking', {
			entryPoint: AiSuggestionsEntryPointValue.SUGGESTIONS_PANEL_HEADER,
		});
	}, [editorAPI]);

	if (source.mode !== 'editor') {
		return null;
	}

	return (
		<Inline alignBlock="center" space="space.050">
			<SuggestionsHeaderActions
				isReviewDisabled={source.isThinking || isOffline}
				onReview={handleReview}
			/>
			<SuggestionsFilterMenu />
		</Inline>
	);
};
